/**
 * @fileoverview Display helpers shared by the caller-rule list (`CallerRules.js`) and its editor (`CallerRuleEditor.js`).
 */

import { FIRM_TZ, firmDate, firmDay, formatDay } from './phoneDashboardFormat';

export function formatPhone(phone) {
  const digits = phone.replace(/\D/g, '').slice(-10);
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}

// Mirrors the phone-system's checks; the backend computes both from the person's phone settings.
export function personStatus(person) {
  if (person.dnd) return 'On DND';
  if (person.in_hours === false) return 'Out of hours';
  return null;
}

// "today", "yesterday" or "on Oct 22", with the year once it isn't this year's. Days are the firm's.
function onDay(iso) {
  const day = formatDay(iso);
  if (day === 'Today' || day === 'Yesterday') return day.toLowerCase();
  const thisYear = firmDay(iso).slice(0, 4) === firmDate().slice(0, 4);
  const date = new Date(iso).toLocaleDateString('en-US', {
    timeZone: FIRM_TZ, month: 'short', day: 'numeric', ...(thisYear ? {} : { year: 'numeric' }),
  });
  return `on ${date}`;
}

// "Added by Pat Example on Oct 21 · Last called today". The phone doesn't record which rule a
// call matched, so this is the last incoming call from the number, which shows a rule nobody needs.
export function ruleHistory(rule) {
  const who = rule.created_by_name || rule.created_by;
  const added = rule.created_at ? `Added${who ? ` by ${who}` : ''} ${onDay(rule.created_at)}` : null;
  const called = rule.last_called_at ? `Last called ${onDay(rule.last_called_at)}` : 'No calls from this number yet';
  return [added, called].filter(Boolean).join(' · ');
}

export function initials(name) {
  return (name || '?').split(/\s+/).filter(Boolean).slice(0, 2).map((part) => part[0].toUpperCase()).join('');
}

// Theme palette hues; the stylesheet blends them into the surface and text colors.
const AVATAR_HUES = ['--blue-500', '--teal-500', '--pink-500', '--orange-500', '--purple-500', '--cyan-500'];

export function avatarHue(key) {
  const n = [...String(key)].reduce((sum, ch) => sum + ch.charCodeAt(0), 0);
  return `var(${AVATAR_HUES[n % AVATAR_HUES.length]}, var(--primary-color))`;
}
